import { render } from "./FormLogin.vue?vue&type=template&id=fa15b64c&scoped=true"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"

import "./FormLogin.vue?vue&type=style&index=0&id=fa15b64c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa15b64c"]])

export default __exports__